// extracted by css-extract-rspack-plugin
export default {"cls1":"ViewsWatcher-cls1_TiG","cls2":"ViewsWatcher-cls2_gnN ViewsWatcher-cls1_TiG"};